/**
 * This is the data displayed on the Home page.
 *
 * This data should be kept current during development in 2018, update this
 * at the same time you update KONE test.
 *
 * Newest entry on top.
 */


const changeLogData: Internal.ChangeLogEntry[] = [
  {
    header: {
      sprint: "438",
      date: "2026-10-19"
    },
    data: [
      "Added a dedicated GrandNorm tab under the Lift page",
      "Integrated a GrandNorm dropdown into the Lift Fault page",
      "Generated the corresponding GrandNorm Header files in '.h', '.cpp', and '.py'"
    ]
  },
  {
    header: {
      sprint: "437",
      date: "2026-10-05"
    },
    data: [
      "Removed duplicate entries from Python exports for Groupfaults",
      "Refactored PDAPI architecture using async/await and service-layer separation",
      "Fixed group API schema validation for parameters and nested lists",
      "Enhanced Fault Component flexibility by making the Domain field optional"
    ]
  },
    {
    header: {
      sprint: "436",
      date: "2026-09-21"
    },
    data: [
      ".Net 10 Migration",
      "Improved the unified naming convention for fault priority labels",
    ]
  },
  {
    header: {
      sprint: "435",
      date: "2026-09-07"
    },
    data: [
      "Implemented the domainmapping JSON file",
      "Fixed the Safety parameter to display in correct sequence",
      "Fixed Excel export to show correct I/O enumeration mask values"
    ]
  },
  {
    header: {
      sprint: "434",
      date: "2026-08-24"
    },
    data: [
      "Migrated PDAPI to .NET 10 with updated package dependencies",
      "Improved the Localization publish with Timmer Trigger functionality",
      "Optimized localization query time and localization triggers",
      "Enhanced sitefault.xml and JSON structure and removed duplicate files in zip",
      "Adhoc- Update LCELIFT (1004) domain faults with the action and description details",
      "Fixed I/O Basic Data Types mask values and I/O Options Enum audit columns",
      "Analysis the UI and requirements for the KCL Licensing Portal implementation"
    ]
  },
  {
    header: {
      sprint: "433",
      date: "2026-08-10"
    },
    data: [
      "Added fault component data for all domains to the new toolsliftcomponents.xml file",
      "Improved Localization Function App memory handling using query splitting",
      "Resolved major security vulnerabilities identified by Zafran",
      "Added audit fields for Common and I/O Enumerations",
      "Supported domain-specific fault priority labels in AMC fault logs"
    ]
  },
    {
    header: {
      sprint: "432",
      date: "2026-07-27"
    },
    data: [
      "Enhanced Time Format in Localization Publish faults",
      "Added audit fields to Lift Event enumeration",
      "Resolved high-critical security vulnerabilities identified in CVMS",
    ]
  },
  {
    header: {
      sprint: "431",
      date: "2026-07-13"
    },
    data: [
      "Enhanced Localization Publish by generation of JSON files for faults, parameters, signals, components, indictors for lift, drive, apm, RTDS, and escalator eventlogs",
      "Automated SiteFault.json Generation for newly added domains",
      "Fixed Data validation for Drive and Escalator parameters and Preferred Values bugs",
      "Enhanced pagination resetting state during add and edit operations"
    ]
  },
  {
    header: {
      sprint: "430",
      date: "2026-06-30"
    },
    data: [
      "Added New Fault Component tab as common for all targets",
      "Implemented the unified domain XML file for all targets for Tools Team",
      "Improved Publish refresh operation for generating xml files",
      "Data Type field is made mandatory in Safety parameter",
      "Improved Domain Group filtering and Drive Faults sorting",
    ]
  },
  {
    header: {
      sprint: "429",
      date: "2026-06-16"
    },
    data: [
      "Enhanced the Lift add and remove bindings to reduce the binding time",
      "Fixed localization publish 500 error when adding a new language",
      "Fixed Message Type deletion failure for Admin accounts and Door External Commands add failure",
      "Disable English/other translations for Group parameters",
      "Fixed IO Board installation order not updating in export when set to zero"
    ]
  },
  {
    header: {
      sprint: "428",
      date: "2026-06-02"
    },
    data: [
      "Upgraded application framework to React 18",
      "Generated a new siteFault.xml file to include faults from all the targets",
      "Displaying Domain column in Parameter Category Table and Export",
      "Improved Localization Status tab accuracy using Domain Group mapping"
    ]
  },
  {
    header: {
      sprint: "427",
      date: "2026-05-19"
    },
    data: [
      "Added Version-specific Min, Max and ItemCount for Parameters",
      "Enhanced Localization status display tab"
    ]
  },
  {
    header: {
      sprint: "426",
      date: "2026-05-05 "
    },
    data: ["Added Fault Configuration fault columns with config.h/config.c generation", "Generate matches.h combining Message Type, Event Class, and Event Type", "Signalization Bulk upload of MDOP faults from Excel"]
  },
  {
    header: {
      sprint: "425",
      date: "2026-05-05"
    },
    data: ["New tab Message Type with eventType and Event Class", "Modify IEX package UI to display versions and Domains of Faults along with parameter", "Implement displaying XDOP,DG faults in group.xml", "Modify Existing Add and Remove Binding API to support Fault Bindings for Escalator"]
  },
  {
    header: {
      sprint: "424",
      date: "2026-04-06"
    },
    data: ["Enhanced backend validation for IO Enumerations", "New process added to onboard Domain Groups for parameters and faults"]
  },
  {
    header: {
      sprint: "423",
      date: "2026-03-27"
    },
    data: ["Enhanced localization across status, translation, and publishing flows", "Added Data Act content to IEX dev packages"]
  },
  {
    header: {
      sprint: "422",
      date: "2026-03-10"
    },
    data: ["Enhanced monitoring configuration options in Status tab", "Implemented the event log feature with localization", "Fixed Monitoring Fault Category localization","Centralized and published safety parameters"]
  },
  {
    header: {
      sprint: "421",
      date: "2026-02-23"
    },
    data: ["Added Monitoring Faults & Fault Category management", "New tab for Escalator Event Log", "Enhanced localization for Network, Monitoring & Signalization status/translation"]
  },{
    header: {
      sprint: "420",
      date: "2026-02-09"
    },
    data: ["Lift LMS SS01/SS03 development & release.", "IEX Dataact development started.", "Monitoring domain Fault development started."]
  }, {
    header: {
      sprint: "419",
      date: "2026-01-28"
    },
    data: ["Add Faults tab added for Network and Signalization domain", "New Api Role added CouldView Team for Faults"]
  },
  {
    header: {
      sprint: "418",
      date: "2026-01-12"
    },
    data: ["New Network and Signalization domain is added", "security hardening for cyber ops", "IEX test license with 3months validity"]
  },
  {
    header: {
      sprint: "417",
      date: "2025-12-29"
    },
    data: ["Escalator Common Enumerations file generation", "Review baseline requirements in IriusRisk for LOTA", "Unit test case improvements for legacy UI components"]
  },
  {
    header: {
      sprint: "416",
      date: "2025-12-15"
    },
    data: ["UMOTA Production Deployment and Testing", "Drive Easy commission XML file generation", "Negative value allowed in common enumerations"]
  },
  {
    header: {
      sprint: "415",
      date: "2025-12-02"
    },
    data: ["New fields added in the device logs API for UMOTA", "UMOTA Azure function deployment in QA Enivronment", "Header file generation for Domain for IEX Team", "faultcodemapping.py is added for Lift Team",]
  },
  {
    header: {
      sprint: "414",
      date: "2025-11-18"
    },
    data: ["Hex value allowed for safety parameters in Bit Mask field", "Header file generation for EventType and Inputlocation for IEX Team", "Logs Added for License API",]
  },
  {
    header: {
      sprint: "413",
      date: "2025-11-04"
    },
    data: ["Header file generation for IEX team", "UMOTA Initial Development", "Phrase Initial setup", "Unit Test case improvements for legacy UI components"]
  },
  {
    header: {
      sprint: "412",
      date: "2025-10-25"
    },
    data: ["Negative value allowed in the Min value of safety parameter", "KFPS changes for IEX and KCE", "OTA Backup support for Elevator", "Restriction of deletion of IO Configuration to Admin role", "New Key Vault Migration process for Licensing service"]
  },
  {
    header: {
      sprint: "411",
      date: "2025-10-07"
    },
    data: ["Data Act Field Added for Apm Faults", "Fault header file with DataAct Changes added to the Development Package", "New Tab Added for Escalator Request Type", "Delete Disable is handled if Domain is mapped to parameter Category"]
  },
  {
    header: {
      sprint: "410",
      date: "2025-09-25"
    },
    data: ["Unit test case add new UI components", "Unit test case added for new API's", "Updated the requirement Documents"]
  },
  {
    header: {
      sprint: "409",
      date: "2025-09-09"
    },
    data: ["Added Translation files for escalator Parameters", "Added Translation files for escalator RTD signals", "Domain Dropdown Added for parameter categories", "Header files generated for escalator modes"]
  },
  {
    header: {
      sprint: "408",
      date: "2025-08-25"
    },
    data: ["Added Data Act code for elevator faults", "New tab added for adding Data Act code", "Added localization for escalator faults", "Added Development package with C and CPP folder", "Translation files added for Door Common Enumeration"]
  },
  {
    header: {
      sprint: "407",
      date: "2025-08-11"
    },
    data: ["New tab added for escalator RTD signals", "New tab added in UI for downloading development package for Escalator", "Drive Parameter Visibility option Dot not use is changed to Not in use", "Parameter Bindings Excel to CSV is Harmonized", "Drive Domain Name changed from KCEDH to KCEKDHN", "Localization files generation for Escalator RTD signals and groups"]
  },
  {
    header: {
      sprint: "406",
      date: "2025-07-28"
    },
    data: ["Escalator RTD Group Added", "Add validation for English Name and Description in Common Enumerations", "Add visibility field to Drive parameter to export CSV", "Localization files added for Door Parameters", "Translation files added for Door Parameters", "PDAPI API .Net version is updated"]
  },
  {
    header: {
      sprint: "405",
      date: "2025-07-15"
    },
    data: ["New Fields are added into Escalator Parameters", "Localization files added Escalator Common Enumerations", "Localization files added Door Common Enumerations and faults", "Minor bug fixes in KCEDB Application"]
  },
  {
    header: {
      sprint: "404",
      date: "2025-06-30"
    },
    data: ["Fault Api's are refactored to use target based fault api both in UI and PDAPI", "Added New fields for safety parameter in UI", "Added Created and Modified details for APM and Non Kone Faults", "PDAPI: IO Config - Update Deck, side and Index to zero as default value"]
  },
  {
    header: {
      sprint: "403",
      date: "2025-06-17"
    },
    data: ["Created and Modified details added for Faults in Lift,Drive,Door and Escalator Targets", "Added New fields for safety parameter in Database", "PDAPI header file generation for common enumerations for Door Domain & Door event Types and Classes"]
  },
  {
    header: {
      sprint: "402",
      date: "2025-06-02"
    },
    data: ["Bug is fixed in Drive Parameter Preferred value", "Feature Value is Added for APM parameter Export", "Code is Replaced with number in version Tab", "PDAPI header file generation for common enumerations for Door Drive Curve,Speed Selection,Board Type,Fault Activity"]
  },
  {
    header: {
      sprint: "401",
      date: "2025-05-19"
    },
    data: ["Added UserGroup filter for Escalator Target", "KCEDB Updated Axios to Stable version", "KCEDB Updated Express to Stable version", "PDAPI Updated SQL Client to Stable version", "PDAPI header file generation for common enumerations for Door Boolean,Request and Response"]
  },
  {
    header: {
      sprint: "400",
      date: "2025-05-06"
    },
    data: ["Added UserGroup filter for Door Target", "Added New UI for escalator Add bindings and remove bindings", "PDAPI Api created for APM faults", "PDAPI Group localization Sync to tools team"]
  },
  {
    header: {
      sprint: "399",
      date: "2025-04-22"
    },
    data: ["Added New UI for Door Add bindings and remove bindings", "Parameter Bindings for door is added in Add parameter", "Added Enumeration Field in Door Faults", "Parameter Bindings is added for Escalator", "Escalator Version Tab is added in Escalator Target", "Added Escalator Version API"]
  },
  {
    header: {
      sprint: "398",
      date: "2025-04-05"
    },
    data: ["Added New Target APM with parameter,faults and Localization", "APM target is added for creating Domain", "Added Escalator Event PID and Ext Cmds", "Door Binding new UI design added", "Door Version API Created"]
  },
  {
    header: {
      sprint: "397",
      date: "2025-03-24"
    },
    data: ["Added Door faults fields in table filter", "Pagination added for Common Enumeration", "Escalator Event PID & Ext Cmds CRUD api's created",]
  },
  {
    header: {
      sprint: "396",
      date: "2025-03-11"
    },
    data: ["Added Event PID & Ext Cmds for Door Target similar to Elevator", "Escalator Event Class & Type created"]
  },
  {
    header: {
      sprint: "395",
      date: "2025-02-24"
    },
    data: ["Added Event Class & Event Type for Door Target similar to Elevator", "Door Event Class/Type CRUD api's created"]
  },
  {
    header: {
      sprint: "394",
      date: "2025-02-10"
    },
    data: ["Usergroup filter added for Parameter for Elevator Target", "Group Parameter Feature Visible issue resolved",
      "Added api for add/edit door event class"]
  },
  {
    header: {
      sprint: "393",
      date: "2025-01-28"
    },
    data: ["Updated Success message of License Generation", "Resolved Category Dropdown issue in Drive Faults Edit Panel",
      "Added Created & Modified date/by for Drive parameter and Safety Parameter", "Added field validation for drive Version add/edit",
      " Generated devicetype.h and devicetype.js files for tools team"]
  },
  {
    header: {
      sprint: "392",
      date: "2025-01-10"
    },
    data: ["Update React Redux version",]
  },
  {
    header: {
      sprint: "391",
      date: "2024-12-30"
    },
    data: ["Added created and modified by/date for Drive Parameter",]
  },
  {
    header: {
      sprint: "390",
      date: "2024-12-16"
    },
    data: ["Localization Tab menu based on user access", "Added Created & Modified By/Date for Esc, Door and Lift",
      "Group Translation upload modification with APM domain", "Generate License Data based on usergroup values"]
  },
  {
    header: {
      sprint: "389",
      date: "2024-12-02"
    },
    data: ["Improved Inconsistent Pagination Behavior", "Parameter Bindings improvement to prevent blank screen",
      "Added Created/Modified Date & By for Group Target", "Tools Sorting Filter Functionality for  Code is resolved",
      "Under Elevator, parameters binding itemcount is fixed"]
  },
  {
    header: {
      sprint: "388",
      date: "2024-11-20"
    },
    data: ["New UI Design Implemented for Left side menu and Make Table fit to screen",
      "Tools License data -> enable/disable license button based on target permission",
      "IO Config - Disable the background when revision and board edit dialog box is open",
      "Make Fault enumeration unique for domain group (Elevator)"]
  },
  {
    header: {
      sprint: "385",
      date: "2024-10-08"
    },
    data: ["view translations API call is reused with store data",
      "Localization translation log Loader gif added",
      "Prevent deletion of Parameter Categories if used in any of the parameters",
      "Make Language field mandatory in Add Language form",
      "Prevent deletion of Electrification if linked to any Domain",
      "AMC Tools code generation added for eventmodes,classes,type,etc"]
  },
  {
    header: {
      sprint: "384",
      date: "2024-09-23"
    },
    data: ["Grey out table page navigation button when disabled",
      "Parameter Categories:updated the validations",
      "Event Enumeration and IO Enumerations: Validation Checks added for Delete",
      "Exception Handling for Add Api's in KCE Database",
      "Genrate tools header files for Elevator modes, event type,class & pid"]
  },
  {
    header: {
      sprint: "383",
      date: "2024-09-09"
    },
    data: ["Localization UI loader & bug fixes",
      "IOConfig dev package download notification time extended",
      "http 400 error codes handled",
      "Added API Roles for CSI, TA teams",
      "Lift IO Node Input filter name implementation"]
  },
  {
    header: {
      sprint: "382",
      date: "2024-08-27"
    },
    data: ["Lift IO Node Input filter time included",
      "CSI, TA Rest Api roles are added",
      "IOOptionsEnumtype UI table added for Lift",
      "Lift IOOptionsEnumType dropdown changes done",
      "Spcae validations added for Localizations & Escalator"]
  },
  {
    header: {
      sprint: "381",
      date: "2024-08-12"
    },
    data: [" Prevent the deletion of Drive signal group and Versions",
      "Group target validation for space validations of mandatory field",
      "Save button enhancements on editing",
      "Exception Handling for Update Api's in KCE Database",
      "Trim spaces (start & end) for text field values in all API's before saving to DB"]
  },
  {
    header: {
      sprint: "380",
      date: "2024-07-29"
    },
    data: ["Event Enumerations format should not include spaces",
      "Drive target for space validations of mandatory field",
      "Add IO Configuration, validation message and make Friendly name mandatory",
      "Lift Params Default values in edit dialog should be updates if index is changed",
      "UI loading error handled for ADD operations",
      "User Account input accepts any format as email address"]
  },
  {
    header: {
      sprint: "379",
      date: "2024-07-15"
    },
    data: ["Localization hide unnecessaty errors",
      "Validate Elevator version input before submission",
      "Implemented Case sensitivity validations [Users, Elevator]",
      "Delete Domain disabled If domain has child parameter or faults",
      "Doamins and parameter category are disabled if you're have read access",
      "Trailing spaces validation is added while adding domain"]

  },
  {
    header: {
      sprint: "378",
      date: "2024-07-03"
    },
    data: ["Allowed zero as fault code for Group and Escalator Domains",
      "Localization[Language]- Add validation info for fields",
      "Make binding details empty while copying parameter[Elevator]",
      "Users can add domains to particular targets only if they have write access",
      "Space validation added for elevator faults mandatory fields",
      "User fields are disabled if user have only read access in Event and IO Enumeration",]
  },
  {
    header: {
      sprint: "377",
      date: "2024-06-18"
    },
    data: ["Incorrect overlay in Elevator bindings", "Excel Export download name changes", "APM filter affects Elevator Target", "Disabled Add Fault in Group Target", "Removed Domain Group checkbox"]
  },
  {
    header: {
      sprint: "376",
      date: "2024-06-03"
    },
    data: ["Read-Only access restriction for Export", "Fault Components, Common enumeration,Domain", "Form Fields Edit for Insufficient Access in Users and AAD Group Tabs", "Event Enumerations improvements", "display what board/revision is currently listed in I/O points", "Lift column sort issues resovled"]
  },
  {
    header: {
      sprint: "375",
      date: "2024-05-20"
    },
    data: ["Read-Only access restriction for ADD", "Form Fields Edit for Insufficient Access in Bindings", "Unique Code in Parameter Domain", "Drive - Versions, Signal", "Signal Groups- Add validation info for fields", "Lift column sort issues resovled"]
  },
  {
    header: {
      sprint: "374",
      date: "2024-05-03"
    },
    data: ["Faults Pages,Electrifications", "Event and IO Enumerations, Products and Versions- Add validation info for fields", "Read-Only Restrictions related to view translation localization", "Esc Fault & Non kone fault code accept only numbers"]
  },
  {
    header: {
      sprint: "373",
      date: "2024-04-22"
    },
    data: ["Made required fields with mandatory validations", "Restrict editing of Parameter fields for read access users", "Overlapping Menus are properly Aligned"]
  },
  {
    header: {
      sprint: "372",
      date: "2024-04-08"
    },
    data: ["Excel export-added min/max/etc values", "Restrict editing of Fault fields for read access users", "Marked Enums fields mandatory"]
  },
  {
    header: {
      sprint: "371",
      date: "2024-03-25"
    },
    data: ["Disable Form Field Editing for Users with Insufficient Access in Parameters Component"]
  },
  {
    header: {
      sprint: "370",
      date: "2024-03-12"
    },
    data: ["IO-Config Add Action & Edit works simultaneously", "Login static error/warning replaced", "Mandatory field highlighted for elevator parameters "]
  },
  {
    header: {
      sprint: "369",
      date: "2024-02-23"
    },
    data: ["IO Configuration notification unifromity", "Load escalator api call on demand", "IO board copy changes for Revision & Std boards", "New endpoint to upload platform license data"]
  },
  {
    header: {
      sprint: "367",
      date: "2024-01-31"
    },
    data: ["Generate escalator/door target license parmas data", "Escalator Parameter View Updates for min/max", "KCE DB Tools2 SSO logout/re-login design change", "Redirect IO Config View Copy link"]
  },
  {
    header: {
      sprint: "366",
      date: "2024-01-19"
    },
    data: ["Lift Fault page data issue related to export excel are resolved"]
  },
  {
    header: {
      sprint: "365",
      date: "2024-01-09"
    },
    data: ["I/O config Std board copy issues are fixed"]
  },
  {
    header: {
      sprint: "364",
      date: "2023-12-13"
    },
    data: ["Pagination Input Field on Focus Out", "Parameter bug fixes", "Added product filer along with domains", "I/O config action data improvements", "UI changes in Drive and Escalator Faults"]
  },
  {
    header: {
      sprint: "363",
      date: "2023-11-27"
    },
    data: ["Parameter category navigation improvements", "Pagination improvements", "I/O config user experience improvements", "Parameter decimal point validations", "Accept String entries as default vlaue(lift)"]
  },
  {
    header: {
      sprint: "362",
      date: "2023-11-13"
    },
    data: ["Parameter number is made unique(lift)", "Made enumerations as editable (Event & I/O)", "Enabled Horizontal scroll bar", "Improvements with Pagination & Table"]
  },
  {
    header: {
      sprint: "361",
      date: "2023-10-25"
    },
    data: ["Add new def/enums to header files", "Added Notification about modified fields", "Included Hex-decimal value in IO Configs", "Parameter value modifications for Elevator"]
  },
  {
    header: {
      sprint: "360",
      date: "2023-10-11"
    },
    data: ["Inform user about expired access token", "Enumeration data improvements", "Default Value for Elevator Parameters", "Localization improvements for Escalator"]
  },
  {
    header: {
      sprint: "359",
      date: "2023-09-25"
    },
    data: ["Filtering in excel exports", "QT Linquistics functionality", "IOConfig Improvements", "License Data Generation "]
  },
  {
    header: {
      sprint: "350",
      date: "2023-06-01"
    },
    data: ["Support for escalator parameters.", "Support for door parameters."]
  },
  {
    header: {
      sprint: "349",
      date: "2023-05-09"
    },
    data: ["Table filtering is effective also in Export to Excel."]
  },
  {
    header: {
      sprint: "348",
      date: "2023-05-05"
    },
    data: ["I/O Config copy from existing config."]
  },
  {
    header: {
      sprint: "342",
      date: "2023-02-08"
    },
    data: ["Translation status details.", "Re-translate indicator in item editors."]
  },
  {
    header: {
      sprint: "337",
      date: "2022-11-25"
    },
    data: ["Locale selection from dropdown.", "Ability to disable a language"]
  },
  {
    header: {
      sprint: "336",
      date: "2022-11-10"
    },
    data: ["Support for escalator faults and door faults.", "Published localization files list"]
  },
  {
    header: {
      sprint: "330",
      date: "2022-08-23"
    },
    data: ["Support for non-KONE faults."]
  },
  {
    header: {
      sprint: "324",
      date: "2022-05-25"
    },
    data: ["Optimized data handling in all items that support localization."]
  },
  {
    header: {
      sprint: "315",
      date: "2022-01-20"
    },
    data: [
      "Support for checking item translation status for parameters, faults, drive signals, groups and tests",
      "License data generation added"
    ]
  },
  {
    header: {
      sprint: "310",
      date: "2021-11-18"
    },
    data: [
      "Enabled google analytics",
      "Added translation status page",
      "Added translation Log page"
    ]
  },
  {
    header: {
      sprint: "305",
      date: "2021-09-06"
    },
    data: ["Group parameter feature column filtering made as dropdown"]
  },
  {
    header: {
      sprint: "303",
      date: "2021-08-09"
    },
    data: [
      "Possibility to give a category for a safety parameter or leave it blank",
      "Support for adding and editing languages"
    ]
  },
  {
    header: {
      sprint: "300",
      date: "2021-06-30"
    },
    data: [
      "Common enumerations localization support",
      "Disable domain enum name change",
      "Manual dismiss for translation notification"
    ]
  },
  {
    header: {
      sprint: "299",
      date: "2021-06-08"
    },
    data: ["Authorize access to Localization/Translation", "Support all roles for user"]
  },
  {
    header: {
      sprint: "298",
      date: "2021-05-25"
    },
    data: [
      "Fixed column settings bug",
      "Write access handling improvements",
      "Support for Group Feature"
    ]
  },
  {
    header: {
      sprint: "297",
      date: "2021-05-19"
    },
    data: ["Common enumerations page added"]
  },
  {
    header: {
      sprint: "297",
      date: "2021-05-11"
    },
    data: ["Added ability to view binary IO configuration files"]
  },
  {
    header: {
      sprint: "294",
      date: "2021-03-30"
    },
    data: ["Create development package added"]
  },
  {
    header: {
      sprint: "293",
      date: "2021-03-18"
    },
    data: ["Publish localizations added"]
  },
  {
    header: {
      sprint: "292",
      date: "2021-03-11"
    },
    data: ["Changed styling of notification items"]
  },
  {
    header: {
      sprint: "289",
      date: "2021-01-26"
    },
    data: ["Changed authentication flow and the library"]
  },
  {
    header: {
      sprint: "284",
      date: "2020-11-13"
    },
    data: ["Support for safety parameters having their own domain: 'SAFETY'"]
  },
  {
    header: {
      sprint: "283",
      date: "2020-10-22"
    },
    data: ["Faultviewer-basic role mapping"]
  },
  {
    header: {
      sprint: "279",
      date: "2020-09-09"
    },
    data: [
      "Login process fixes",
      "Showing full category path instead of category name in group parameter table and editor"
    ]
  },
  {
    header: {
      sprint: "278",
      date: "2020-08-28"
    },
    data: [
      "Added login screen",
      "Added user context menu",
      "Added logout button to user context menu",
      "Refactored access token request process",
      "Changed lift-write role to have modify permissions for ioConfig and standardBoards"
    ]
  },
  {
    header: {
      sprint: "277",
      date: "2020-08-14"
    },
    data: [
      "AAD login option added",
      "Added User Authorization based on AAD groups",
      "Users -> AADGroups page added to map aadgroup to roles"
    ]
  },
  {
    header: {
      sprint: "274",
      date: "2020-07-02"
    },
    data: ["Added copy support for domains"]
  },
  {
    header: {
      sprint: "274",
      date: "2020-06-26"
    },
    data: [
      "Removed mock back-end json files",
      "Removed un used css codes",
      "Adjusted some minor broken styles in some editors"
    ]
  },
  {
    header: {
      sprint: "274",
      date: "2020-06-24"
    },
    data: ["Changed Lift text which are visible in the UI to Elevator"]
  },

  {
    header: {
      sprint: "274",
      date: "2020-06-22"
    },
    data: ["Visual updates on the User's page action menu"]
  },

  {
    header: {
      sprint: "274",
      date: "2020-06-23"
    },
    data: [
      "Added domain group specific background pre-fetching of parameters after app is loaded",
      "Added background pre-fetching of faults after app is loaded",
      "Default fetching order of parameters [Lift, Drive, Group] can be prioritized when user roles are implemented"
    ]
  },
  {
    header: {
      sprint: "274",
      date: "2020-06-21"
    },
    data: ["Added loading indicator for the table view"]
  },
  {
    header: {
      sprint: "273",
      date: "2020-06-11"
    },
    data: [
      "LiftBindings view visual updates",
      "DriveBindings view visual updates",
      "Versions and Products view visual updates",
      "New child routes to the LiftBindings and DriveBindings route"
    ]
  },
  {
    header: {
      sprint: "272",
      date: "2020-06-05"
    },
    data: ["Table row scaling improved"]
  },
  {
    header: {
      sprint: "272",
      date: "2020-06-02"
    },
    data: [
      "Excluded the loading of FAULTS and PARAMETERS from initial page load",
      "Load the PARAMETERS data when user goes to PARAMETERS child page of lift, drive, safety, APM or group page",
      "Load the FAULTS data when user goes to PARAMETERS child page of lift, drive or group page",
      "Removed unnecessary function call with Redux Connect() from some child components"
    ]
  },
  {
    header: {
      sprint: "272",
      date: "2020-05-29"
    },
    data: [
      "Enumerations-> Electrifications : Added support for adding/updating/deleting Electrifitions",
      "Enumerations-> Domains : Added support for adding/removing electrifications for domains",
      "Lift -> Lift Bindings : Fixed bug making page to not show"
    ]
  },
  {
    header: {
      sprint: "271",
      date: "2020-05-20"
    },
    data: [
      "Added support for adding/updating/deleting Io Configuration item",
      "- Adding new Io Configuration item",
      "- Editing existing Io Configuration item",
      "- Deleting existing Io Configuration item",
      "- Copying existing Io Configuration item and creating new Io configuration item based on that"
    ]
  },
  {
    header: {
      sprint: "271",
      date: "2020-05-19"
    },
    data: [
      "Fixed inconsistent automatic scrolling to next action when using search function next result button in IoConfig View ",
      "Fixed scaling issues of IoConfig boards and points column height on lower resolution screens",
      "Pagination navigation component is now fixed to bottom of screen, not end of results"
    ]
  },
  {
    header: {
      sprint: "271",
      date: "2020-05-18"
    },
    data: [
      "Added support for searching event types/classes in io config and standard boards view",
      "- Auto complete search field when only one option available",
      "- Search only inside opened node, option to search next node"
    ]
  },
  {
    header: {
      sprint: "271",
      date: "2020-05-12"
    },
    data: [
      "I/O Config View : Load indicator added when opening new ioConfiguration",
      "I/O Basic Data Type editor updated",
      "I/O Data section editor updated"
    ]
  },
  {
    header: {
      sprint: "270",
      date: "2020-05-08"
    },
    data: [
      "I/O Config View Added under Tools page",
      "Standard Board View moved to under I/O config View",
      "I/O Config View : Add Io Board by selecting standard Board",
      "I/O Config View : Add/Edit Point/action support",
      "I/O Config View : Copy/paste actions from point to point support",
      "Standard Boards View: Updated add/edit board editor with new boardType selector and node editor"
    ]
  },
  {
    header: {
      sprint: "269",
      date: "2020-04-24"
    },
    data: [
      "Standard Boards view: Loading -indicator added if points are not ready when user clicks Node"
    ]
  },
  {
    header: {
      sprint: "269",
      date: "2020-04-23"
    },
    data: [
      "Standard Boards view added under Tools page (will be moved once whole ioConfig menu structure is decided)",
      "Add board and Edit Node support",
      "Add/Edit Point/action support",
      "Copy/paste actions from point to point support",
      "KCE Product and KCE Versions renamed to Products/Versions"
    ]
  },
  {
    header: {
      sprint: "267",
      date: "2020-03-19"
    },
    data: ["Changed api connection from localization-api to PDApi"]
  },
  {
    header: {
      sprint: "266",
      date: "2020-03-13"
    },
    data: [
      "Added Lift -> IO Enumerations page ",
      "Added crud support for io enumerations excluding basic data types"
    ]
  },
  {
    header: {
      sprint: "266",
      date: "2020-03-09"
    },
    data: [
      "Added Lift -> Event Enumerations page ",
      "Added crud support for event classes, types, pids and ext commands"
    ]
  },
  {
    header: {
      sprint: "266",
      date: "2020-02-29"
    },
    data: [
      "Tables updated according to new UI Design",
      "Side editor updated according to new UI Design",
      "Added Dimmer to disable clicking outside editor when editing"
    ]
  },
  {
    header: {
      sprint: "265",
      date: "2020-02-24"
    },
    data: [
      "Main containers have been refactored to use same template file",
      "Submenu and action menu refactored according to new UI styling",
      "Top menu moved to side according to new UI styling"
    ]
  },
  {
    header: {
      sprint: "264",
      date: "2020-02-14"
    },
    data: [
      "Parameter bindings are sorted in lift and drive parameter editors. Also some improvements in editing them.",
      "Moved delete and copy buttons to sidebar",
      "Added uniqueness check to enumerations-field in lift fault editor"
    ]
  },
  {
    header: {
      sprint: "263",
      date: "2020-01-29"
    },
    data: [
      "Support for Drive Test CRUD",
      "Support for Safety Parameters CRUD",
      "Support for editing parameter categories"
    ]
  },
  {
    header: {
      sprint: "263",
      date: "2020-01-23"
    },
    data: ["Support for editing drive signals and drive signal groups"]
  },
  {
    header: {
      sprint: "262",
      date: "2020-01-10"
    },
    data: ["Refactored submenu handling"]
  },
  {
    header: {
      sprint: "260",
      date: "2019-12-18"
    },
    data: [
      "Navigation re-ordered, domain groups on top",
      "Make table header position fixed",
      "Make create/save button group position fixed",
      "Add scroll bar to table",
      "Add scroll bar to edit view",
      "Change font to KONE font"
    ]
  },
  {
    header: {
      sprint: "255",
      date: "2019-10-03"
    },
    data: ["Separate APM Parameters tab"]
  },
  {
    header: {
      sprint: "254",
      date: "2019-09-24"
    },
    data: ["Internal refactoring", "Fix navigation issues", "Fix package vulnerabilities"]
  },
  {
    header: {
      sprint: "244",
      date: "2019-05-15"
    },
    data: ["Internal refactoring"]
  },
  {
    header: {
      sprint: "235",
      date: "2019-01-11"
    },
    data: ["Add CRUD (Create Read Update Delete) for Drive Versions."]
  },
  {
    header: {
      sprint: "235",
      date: "2019-01-08"
    },
    data: [
      "Adding/removing bindings to lift and drive parameters added.",
      "Disabled editing domain and fault component code.",
      "Add CRUD (Create Read Update Delete) for KCE Products and Versions."
    ]
  },
  {
    header: {
      sprint: "235",
      date: "2019-01-03"
    },
    data: [
      "Drive's parameter bindings are editable.",
      "Creating a new parameter (Drive/Lift/Group) fixed."
    ]
  },
  {
    header: {
      sprint: "234",
      date: "2018-12-13"
    },
    data: ["Lift parameter vector binding and editor defines are editable."]
  },
  {
    header: {
      sprint: "234",
      date: "2018-12-12"
    },
    data: [
      "Full path shown in selection of parameter categories.",
      "Duplicate code id in one domain allowed for Group parameters.",
      "Copy source of default values changed to the selected values instead of default."
    ]
  },
  {
    header: {
      sprint: "233",
      date: "2018-12-03"
    },
    data: [
      "Number of UI fixes including text, borders, logo as navigation and more consistent margins.",
      "Fix base url for the application"
    ]
  },
  {
    header: {
      sprint: "233",
      date: "2018-11-29"
    },
    data: [
      "Number of UI fixes including page size, 404 page, group naming and more consistent notifications.",
      "Lift parameter binding and sw default values are editable.",
      "Drive parameter value data format is editable."
    ]
  },
  {
    header: {
      sprint: "233",
      date: "2018-11-28"
    },
    data: ["Add user right checks."]
  },
  {
    header: {
      sprint: "233",
      date: "2018-11-27"
    },
    data: [
      "Global table settings regarding page sizes.",
      "Edit view size as editable with a couple of enums.",
      "Change Group to Grouping.",
      "Remove ID columns.",
      "Sort everything by code value",
      "Small visual fixes"
    ]
  },
  {
    header: {
      sprint: "233",
      date: "2018-11-26"
    },
    data: ["Drive parameter value data format is editable.", "Add url navigation to application."]
  },
  {
    header: {
      sprint: "232",
      date: "2018-11-22"
    },
    data: [
      "First version to KONE test.",
      "Style fixes and unification to all components",
      "CRUD (Create Read Update Delete) for Domains to Enumerations.",
      "Export to Excel in CSV format to all components.",
      "CRUD for Fault Components to Enumerations."
    ]
  },
  {
    header: {
      sprint: "232",
      date: "2018-11-13"
    },
    data: [
      "A list of changes to Home.",
      "Modal confirmation dialog to Delete Users.",
      "Copy one item to Parameters and Faults.",
      "Add and Delete to Users.",
      "Table settings to Parameters and Faults."
    ]
  },
  {
    header: {
      sprint: "231, First entry",
      date: "2018-11-01"
    },
    data: ["Table to Parameters, Faults and Users.", "Editor to Parameters, Faults and Users."]
  }
];

export default changeLogData;
